import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-what-we-do4',
  templateUrl: './section-what-we-do4.component.html',
  styleUrls: ['./section-what-we-do4.component.css']
})
export class SectionWhatWeDo4Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
